import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { httpGet, httpPost } from "../../services/httpService";
import {
  getAppUrl,
  userChangeCompanyUrl,
  getCompanyNamesUrl,
  updateLastLoginByEmailUrl,
  updateUserCurrentStatusUrl,
  updateLogoutByEmailUrl,
  getIntercomDetailUrl,
  getDemDxDetailUrl,
} from "../../apiUrls/apiUrls";
import { logErrorWithPayload } from "../../services/logService";
import { jwtDecode } from "jwt-decode";

const initialState = {
  isSelectionScreen: true,
  isTeamUpdated: false,
  selectedTeamIndex: "",
  isValidOrg: false,
  hasNoTeams: false,
  isOrbitUser: false,
  isOrbitSwitch: false,
  isChatVisible: false,
  isOrbitVisible: false,
  isAppLoading: false,
  isTabLoading: false,
  darkMode: localStorage.getItem("darkMode") === "true" || false,
  theme:
    localStorage.getItem("darkMode") === "true" ? "dark-theme" : "light-theme",
  companyId: "",
  currentCompanyId: "",
  currentPharmacyId: "00000000-0000-0000-0000-000000000000",
  currentPharmacy: null,
  currentTeamId: "",
  currentTeam: null,
  currentUser: null,
  serviceCounts: [],
  company: null,
  teams: [],
  companyDetails: null,
  pharmacies: [],
  userPermissions: [],
  authToken: localStorage.getItem("authToken") || "",
  features: {
    ifMapEnabled: true,
    ifClinicalChecksEnabled: true,
    ifPatientEnabled: true,
    ifClinicalservicesEnabled: true,
    ifCustomerExperienceEnabled: true,
    ifPatientDashboardEnabled: true,
    ifPatientListEnabled: true,
    ifPharmacyOverviewEnabled: true,
    ifPatientSearchEnabled: true,
    ifChatEnabled: true,
    ifSettingEnabled: true,
    ifSettingMinimal: true,
    ifSendToOrbit: true,
    ifPharmacyAction: true,
    ifCreateService: true,
    ifAgencyFeature: true,
    ifListEnabled: true,
    ifKanbanSearchBoxEnabled: true,
    ifWorkForceTabEnabled: true,
    ifScheduleTabEnabled: true,
    ifAIConsultationEnabled: true,
    ifPrescriptionApprovalEnabled: true,
    NewPatientDashboard: true,
    featuresData: [],
    ifPharmacyDashboardEnabled: true,
    ifDocumentsEnabled: true,
    ifBillingEnabled: true,
    ifNHS111ServiceEnabled: true,
    ifPharmacyAnalyticsEnabled: true,
    ifCalculatorAcitonsEnabled: true,
    ifDashboardKPIEnabled: true,
    ifHeadOfficeEnabled: true,
    ifTreatmentPlanEnabled: true,
    ifNews2Enabled: true,
    ifNewCalendar: true,
    ifPharmacyFirstEnabled: true,
    ifAHTWeightManagementEnabled: true,
  },
  changeCompany: null,
  showPatientSearchModal: false,
  headerTeamMembers: [],
  showInviteModal: false,
  showInviteTeamSideModal: false,
  globalTab: 0,
  globalTabText: "PharmacyDashboard",
  isAgencyUser: false,
  selectedPatient: "",
  superAdmin: false,
  isPatientSearched: false,
  patientInfoTab: localStorage.getItem("patientInfoTab")
    ? Number(localStorage.getItem("patientInfoTab"))
    : 0,
  intercomDetail: "",
  routedFromScheduler: false,
  showProfileModal: false,
  consultationLoadError: false,
  showIdlePopup: false,
  showSettingsModal: false,
  settingsActiveTab: "general",
  showPermissionModal: false,
  showPermissionMessage: "Permission Required",
  dashboardTeams: null,
};

export const getAppData = createAsyncThunk(
  "app/getAppData",
  async (featureSearchType = 6, thunkAPI) => {
    const urlToGet = getAppUrl(featureSearchType);
    const respData = await httpGet(urlToGet);
    return respData;
  },
);
export const userChangeCompanyData = createAsyncThunk(
  "app/userChangeCompanyData",
  async (params, thunkAPI) => {
    const { email, type, companyId } = params;
    const respData = await httpGet(
      userChangeCompanyUrl(email, type, companyId),
    );
    return respData;
  },
);
export const getCompanyNamesData = createAsyncThunk(
  "app/getCompanyNamesData",
  async (params, thunkAPI) => {
    const { oldCompanyId, newCompanyId } = params;
    const respData = await httpGet(
      getCompanyNamesUrl(oldCompanyId, newCompanyId),
    );
    return respData;
  },
);
export const updateLastLoginByEmailData = createAsyncThunk(
  "app/updateLastLoginByEmailData",
  async (thunkAPI) => {
    const respData = await httpPost(updateLastLoginByEmailUrl());
    return respData;
  },
);
export const updateUserCurrentStatusData = createAsyncThunk(
  "app/updateUserCurrentStatusData",
  async (statusType, thunkAPI) => {
    const respData = await httpGet(updateUserCurrentStatusUrl(statusType));
    return respData;
  },
);
export const updateLogoutByEmailData = createAsyncThunk(
  "app/updateLastLoginByEmailData",
  async (thunkAPI) => {
    const respData = await httpPost(updateLogoutByEmailUrl());
    return respData;
  },
);
export const getIntercomDetailData = createAsyncThunk(
  "app/getIntercomDetailData",
  async (params, thunkAPI) => {
    const urlToGet = getIntercomDetailUrl();
    const respData = await httpGet(urlToGet);
    return respData;
  },
);

export const getDemDxDetailData = createAsyncThunk(
  "app/getDemDxDetailData",
  async (params, thunkAPI) => {
    const urlToGet = getDemDxDetailUrl();
    const respData = await httpGet(urlToGet);
    return respData;
  },
);

export const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setIsValidOrg: (state, action) => {
      state.isValidOrg = action?.payload || false;
    },
    setIsChatVisible: (state, action) => {
      state.isChatVisible = action?.payload || false;
    },
    setIsOrbitSessionData: (state, action) => {
      state.isOrbitVisible = action?.payload || false;
    },
    setIsAppLoading: (state, action) => {
      state.isAppLoading = action?.payload || false;
    },
    setIsSelectionScreenData: (state, action) => {
      state.isSelectionScreen = action?.payload;
    },
    setIsTeamUpdatedData: (state, action) => {
      state.isTeamUpdated = action?.payload || false;
    },
    setIsSelectedTeamIndexData: (state, action) => {
      state.selectedTeamIndex = action?.payload || "";
    },
    setIsTabLoading: (state, action) => {
      state.isTabLoading = action?.payload || false;
    },
    setOrbitUser: (state, action) => {
      state.isOrbitSwitch = action?.payload || false;
    },
    setGlobalTab: (state, action) => {
      state.globalTab = action?.payload || 0;
    },
    setGlobalTabText: (state, action) => {
      state.globalTabText = action?.payload || "";
    },
    setAuthToken: (state, action) => {
      const auth0Token = action?.payload || "";
      state.authToken = auth0Token;
      if (auth0Token != "") {
        const decoded = jwtDecode(auth0Token);
        const permissions = decoded.permissions || decoded.scope;
        state.userPermissions = permissions;
      }
      localStorage.setItem("authToken", auth0Token);
    },
    removeAuthToken: (state) => {
      state.authToken = "";
      localStorage.removeItem("authToken");
    },
    setDarkModeTheme: (state, action) => {
      state.darkMode = action?.payload || false;
      state.theme = state.darkMode === true ? "dark-theme" : "light-theme";
      localStorage.setItem("darkMode", state.darkMode);
    },
    setPharmacy: (state, action) => {
      state.currentPharmacy = action?.payload || null;
      state.currentPharmacyId =
        state.currentPharmacy?.teamPharmacyID ||
        "00000000-0000-0000-0000-000000000000";
    },
    setTeam: (state, action) => {
      state.currentTeam = action?.payload || null;
      var team = state.currentTeam;
      state.currentTeamId = state.currentTeam?.teamID || "";
      const selectedCompanyId = state.currentCompanyId;
      if (selectedCompanyId) {
        state.companyId = selectedCompanyId || "";
      } else {
        state.companyId = state?.currentTeam?.companyID || "";
      }
      state.pharmacies = state.currentTeam?.pharmacies || [];
      if (
        state?.pharmacies &&
        Array.isArray(state?.pharmacies) &&
        state?.pharmacies?.length > 0 &&
        state?.pharmacies[0]?.teamPharmacyID
      ) {
        state.currentPharmacy = state.pharmacies[0];
        state.currentPharmacyId =
          state.pharmacies[0]?.teamPharmacyID ||
          "00000000-0000-0000-0000-000000000000";
      }
    },
    setPharmaciesData: (state, action) => {
      state.pharmacies = action?.payload || [];
    },
    setDasboardTeam: (state, action) => {
      state.dashboardTeams = action?.payload || null;
    },
    replaceAppState: (state, action) => {
      return action?.payload || initialState;
    },
    setShowPatientSearchModalData: (state, action) => {
      state.showPatientSearchModal = action.payload || false;
    },
    setHeaderTeamMembersData: (state, action) => {
      state.headerTeamMembers = action.payload || [];
    },
    setShowInviteModalData: (state, action) => {
      state.showInviteModal = action.payload || false;
    },
    setShowInviteTeamSideModalData: (state, action) => {
      state.showInviteTeamSideModal = action.payload || false;
    },
    setisAgencyUserData: (state, action) => {
      state.isAgencyUser = action?.payload || false;
    },
    setCurrentTeamIdData: (state, action) => {
      state.currentTeamId = action?.payload || "";
    },
    setCurrentIsPatientSearched: (state, action) => {
      state.isPatientSearched = action?.payload || false;
    },
    setCurrentPatientInfoTab: (state, action) => {
      state.patientInfoTab = action?.payload || 0;
    },
    setCurrentTeamsData: (state, action) => {
      state.teams = action?.payload || [];
    },
    setRoutedFromSchedulerData: (state, action) => {
      state.routedFromScheduler = action?.payload || false;
    },
    setShowProfileModalData: (state, action) => {
      state.showProfileModal = action?.payload || false;
    },
    setConsultationLoadErrorData: (state, action) => {
      state.consultationLoadError = action.payload;
    },
    setShowIdlePopupData: (state, action) => {
      state.showIdlePopup = action.payload || false;
    },
    setShowSettingsModalData: (state, action) => {
      state.showSettingsModal = action.payload || false;
    },
    setSettingsActiveTabData: (state, action) => {
      state.settingsActiveTab = action.payload || "general";
    },
    setCompanyIdData: (state, action) => {
      state.companyId = action.payload || "";
    },
    setCurrentCompanyIdData: (state, action) => {
      state.currentCompanyId = action.payload || "";
    },
    setShowPermissionModalData: (state, action) => {
      state.showPermissionModal = action.payload || false;
    },
    setShowPermissionMessageData: (state, action) => {
      state.showPermissionMessage = action.payload || "Permission Required";
    },

    resetAppState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAppData.pending, (state) => {
        state.isAppLoading = true;
      })
      .addCase(getAppData.fulfilled, (state, action) => {
        const appDataFromResponse = action?.payload;
        const calculateScores = () => {
          try {
            const { teams, serviceCounts, company } = appDataFromResponse || {};
            state.company = company;
            state.serviceCounts = serviceCounts;
            if (teams && Array.isArray(teams) && teams?.length > 0) {
              for (const team of teams) {
                const pharmacies = team.pharmacies || [];
                for (const pharmacy of pharmacies) {
                  let totalKPIsPercentage = 0;
                  let clinicalScore = 0;
                  let operationsScore = 0;
                  let financeScore = 0;
                  let efficiencyScore = 0;

                  if (pharmacy.clinicalKPI) {
                    totalKPIsPercentage += pharmacy.clinicalKPI?.kpiPercentage;
                    clinicalScore += pharmacy.clinicalKPI?.kpiPercentage ?? 0;
                  }

                  if (pharmacy.operationsKPI) {
                    totalKPIsPercentage +=
                      pharmacy.operationsKPI?.kpiPercentage;
                    operationsScore +=
                      pharmacy.operationsKPI?.kpiPercentage ?? 0;
                  }

                  if (pharmacy.financeKPI) {
                    totalKPIsPercentage += pharmacy.financeKPI?.kpiPercentage;
                    financeScore += pharmacy.financeKPI?.kpiPercentage ?? 0;
                  }

                  if (pharmacy.efficiencyKPI) {
                    totalKPIsPercentage +=
                      pharmacy.efficiencyKPI?.kpiPercentage;
                    efficiencyScore +=
                      pharmacy.efficiencyKPI?.kpiPercentage ?? 0;
                  }

                  pharmacy.totalKPIPercentage = totalKPIsPercentage / 4;
                  pharmacy.clinicalScore = clinicalScore;
                  pharmacy.operationsScore = operationsScore;
                  pharmacy.financeScore = financeScore;
                  pharmacy.efficiencyScore = efficiencyScore;
                }
              }
            }
          } catch (error) {
            logErrorWithPayload(error, action?.payload);
          }
        };

        if (appDataFromResponse) {
          try {
            appDataFromResponse.teams = Array.isArray(appDataFromResponse.teams)
              ? appDataFromResponse.teams?.sort((team_global, team) => {
                  if (team_global.isGlobalView && !team.isGlobalView) {
                    return -1;
                  }
                  if (!team_global.isGlobalView && team.isGlobalView) {
                    return 1;
                  }

                  return 0;
                })
              : [];

            const {
              companyID,
              applicationFeatures,
              teams,
              company,
              isOrbitUser,
              user,
            } = appDataFromResponse || {
              companyID: "00000000-0000-0000-0000-000000000000",
            };
            calculateScores();
            const storedOption = localStorage.getItem("selectedOption");
            if (storedOption === "orbit") {
              state.isOrbitUser = true;
            } else {
              state.isOrbitUser = isOrbitUser || false;
            }
            state.features.featuresData =
              applicationFeatures?.applicationFeatures || [];
            state.teams = teams || [];
            const userEmail = user?.emailAddress?.toLowerCase();
            const isUserInAnyTeam = teams?.some((team) =>
              team.teamMembers?.some(
                (m) =>
                  m.email?.toLowerCase() === userEmail &&
                  m.teamJoiningStatus !== 4 &&
                  m.teamJoiningStatus !== 5
              )
            );
            state.hasNoTeams = !isUserInAnyTeam;
            state.companyDetails = company || [];
            state.headerTeamMembers =
              teams.flatMap((team) => team.teamMembers) || [];
            state.currentUser = user || null;
            if (user !== null) {
              try {
                const userId = user?.fullName;
                const userAttributes = {
                  email: user?.emailAddress,
                  subscription_level: "pro",
                };
              } catch (error) {
                console.log(error);
              }
            }
            if (state?.isTeamUpdated) {
              const currentTeamIndex = state?.selectedTeamIndex;
              state.currentTeam = state?.teams[currentTeamIndex] || null;
              state.dashboardTeams = state?.teams[currentTeamIndex] || null;

              state.currentTeamId = state?.currentTeam?.teamID || "";
              state.headerTeamMembers =
                state?.teams[currentTeamIndex].teamMembers;
              state.pharmacies = state?.currentTeam?.pharmacies || [];
              const selectedCompanyId = state.currentCompanyId;
              if (selectedCompanyId) {
                state.companyId = selectedCompanyId || "";
              } else {
                state.companyId = state?.currentTeam?.companyID || "";
              }
              if (
                state?.pharmacies &&
                Array.isArray(state?.pharmacies) &&
                state?.pharmacies?.length > 0 &&
                state?.pharmacies[0]?.teamPharmacyID
              ) {
                state.currentPharmacy = state?.pharmacies[0];
                state.currentPharmacyId =
                  state.pharmacies[0]?.teamPharmacyID ||
                  "00000000-0000-0000-0000-000000000000";
              }
            } else {
              let index = state?.teams?.findIndex(
                (eachTeam) => eachTeam.isGlobalView === true,
              );
              index = index === -1 ? 0 : index;
              state.currentTeam = state?.teams[index] || null;
              const dashboardTeams = state.dashboardTeams;
              if (dashboardTeams === null) {
                state.dashboardTeams = state?.teams[index] || null;
              }
              state.currentTeamId = state?.currentTeam?.teamID || "";
              state.headerTeamMembers = state.currentTeam?.teamMembers || [];
              const selectedCompanyId = state.currentCompanyId;

              if (selectedCompanyId) {
                state.companyId = selectedCompanyId || "";
              } else {
                state.companyId = state?.currentTeam?.companyID || "";
              }
              state.pharmacies = state?.currentTeam?.pharmacies || [];

              if (
                state?.pharmacies &&
                Array.isArray(state?.pharmacies) &&
                state?.pharmacies?.length > 0 &&
                state?.pharmacies[0]?.teamPharmacyID
              ) {
                if (
                  state.currentPharmacyId ===
                    "00000000-0000-0000-0000-000000000000" ||
                  state.currentPharmacyId === "" ||
                  state.currentPharmacyId === null
                ) {
                  state.currentPharmacy = state?.pharmacies[0];
                  state.currentPharmacyId =
                    state.pharmacies[0]?.teamPharmacyID ||
                    "00000000-0000-0000-0000-000000000000";
                }
              }
            }
            if (
              state?.features?.featuresData &&
              Array.isArray(state?.features?.featuresData)
            ) {
              const { featuresData } = state?.features || {};
              featuresData?.map((item) => {
                const { feature, isEnabled } = item || {};
                const isSuperAdmin =
                  user?.role.roleName === "Super Admin" ? true : false;
                state.superAdmin = isSuperAdmin;
                switch (feature) {
                  case 1:
                    state.features.ifMapEnabled = isEnabled || false;
                    break;
                  case 2:
                    state.features.ifClinicalChecksEnabled = isEnabled || false;
                    break;
                  case 3:
                    state.features.ifClinicalservicesEnabled =
                      isEnabled || false;
                    break;
                  case 4:
                    state.features.ifCustomerExperienceEnabled =
                      isEnabled || false;
                    break;
                  case 5:
                    state.features.ifPatientDashboardEnabled =
                      isEnabled || false;
                    break;
                  case 6:
                    state.features.ifPatientListEnabled = isEnabled || false;
                    break;
                  case 7:
                    state.features.ifPharmacyOverviewEnabled =
                      isEnabled || false;
                    break;
                  case 8:
                    state.features.ifPatientSearchEnabled = isEnabled || false;
                    break;
                  case 9:
                    state.features.ifChatEnabled = isEnabled || false;
                    break;
                  case 10:
                    state.features.ifSettingEnabled = isEnabled || false;
                    break;
                  case 11:
                    state.features.ifSettingMinimal = isEnabled || false;
                    break;
                  case 12:
                    state.features.ifSendToOrbit = isEnabled || false;
                    break;
                  case 13:
                    state.features.ifPharmacyAction = isEnabled || false;
                    break;
                  case 14:
                    state.features.ifCreateService = isEnabled || false;
                    break;
                  case 15:
                    state.features.ifAgencyFeature = isEnabled || false;
                    break;
                  case 16:
                    state.features.ifListEnabled =
                      isEnabled || isSuperAdmin || false;
                    break;
                  case 17:
                    state.features.ifKanbanSearchBoxEnabled =
                      isEnabled || false;
                    break;
                  case 18:
                    state.features.ifWorkForceTabEnabled = isEnabled || false;
                    break;
                  case 19:
                    state.features.ifScheduleTabEnabled = isEnabled || false;
                    break;
                  case 20:
                    state.features.ifAIConsultationEnabled = isEnabled || false;
                    break;
                  case 21:
                    state.features.NewPatientDashboard = isEnabled || false;
                    break;
                  case 22:
                    state.features.ifPharmacyDashboardEnabled =
                      isEnabled || false;

                    if (!sessionStorage.getItem("tabSessionInitialized")) {
                      sessionStorage.setItem("tabSessionInitialized", "true");

                      localStorage.removeItem("globalTab");
                      localStorage.removeItem("patientInfoTab");
                      localStorage.removeItem("globalTabText");
                      localStorage.removeItem("hasSetGlobalTabText");
                    }

                    if (window.location.pathname === "/") {
                      localStorage.removeItem("globalTab");
                      localStorage.removeItem("patientInfoTab");
                      localStorage.removeItem("globalTabText");
                      localStorage.removeItem("hasSetGlobalTabText");
                    }

                    const hasSetGlobalTabText = localStorage.getItem(
                      "hasSetGlobalTabText",
                    );

                    if (!hasSetGlobalTabText) {
                      localStorage.setItem("globalTab", 0);
                      localStorage.setItem("patientInfoTab", 0);

                      if (state.features.ifPharmacyDashboardEnabled) {
                        localStorage.setItem(
                          "globalTabText",
                          "PharmacyDashboard",
                        );
                      } else {
                        localStorage.setItem("globalTabText", "Services");
                      }

                      localStorage.setItem("hasSetGlobalTabText", "true");
                    }

                    break;

                  case 23:
                    state.features.ifDocumentsEnabled = isEnabled || false;
                    break;

                  case 24:
                    state.features.ifBillingEnabled = isEnabled || false;
                    break;
                  case 25:
                    state.features.ifNHS111ServiceEnabled = isEnabled || false;
                    break;
                  case 26:
                    state.features.ifPharmacyAnalyticsEnabled =
                      isEnabled || false;
                    break;
                  case 27:
                    state.features.ifCalculatorAcitonsEnabled =
                      isEnabled || false;
                    break;
                  case 28:
                    state.features.ifDashboardKPIEnabled = isEnabled || false;
                  case 30:
                    state.features.ifHeadOfficeEnabled = isEnabled || false;
                    break;
                  case 29:
                    state.features.ifTreatmentPlanEnabled = isEnabled || false;
                    break;
                  case 31:
                    state.features.ifNews2Enabled = isEnabled || false;
                    break;
                  case 32:
                    state.features.ifNewCalendar = isEnabled || false;
                    break;
                  case 33:
                    state.features.ifPharmacyFirstEnabled = isEnabled || false;
                    break;
                  case 34:
                    state.features.ifAHTWeightManagementEnabled = isEnabled || false;
                    break;
                  default:
                }
              });
            }

            if (state.features.ifPharmacyDashboardEnabled) {
              state.globalTab = localStorage.getItem("globalTab")
                ? Number(localStorage.getItem("globalTab"))
                : 0;

              state.globalTabText = localStorage.getItem("globalTabText")
                ? localStorage.getItem("globalTabText")
                : "PharmacyDashboard";
            } else {
              state.globalTab = localStorage.getItem("globalTab")
                ? Number(localStorage.getItem("globalTab"))
                : 1;

              state.globalTabText = localStorage.getItem("globalTabText")
                ? localStorage.getItem("globalTabText")
                : "Services";
            }

            if (
              state.isOrbitUser === false &&
              (!state.companyId ||
                !state.currentPharmacyId ||
                state.currentPharmacyId ===
                  "00000000-0000-0000-0000-000000000000")
            ) {
              state.isValidOrg = false;
            } else {
              state.isValidOrg = true;
            }
          } catch (error) {
            logErrorWithPayload(error, action?.payload);
          }
        }
        state.isAppLoading = false;
      })
      .addCase(getAppData.rejected, (state, action) => {
        logErrorWithPayload(action?.error, action?.payload);
        state.isAppLoading = false;
      })
      .addCase(userChangeCompanyData.pending, (state) => {
        state.isAppLoading = true;
      })
      .addCase(userChangeCompanyData.fulfilled, (state, action) => {
        state.isAppLoading = false;
      })
      .addCase(userChangeCompanyData.rejected, (state, action) => {
        logErrorWithPayload(action?.error, action?.payload);
        state.isAppLoading = false;
      })
      .addCase(getCompanyNamesData.pending, (state) => {
        state.isAppLoading = true;
      })
      .addCase(getCompanyNamesData.fulfilled, (state, action) => {
        state.isAppLoading = false;
        state.changeCompany = action?.payload;
      })
      .addCase(getCompanyNamesData.rejected, (state, action) => {
        logErrorWithPayload(action?.error, action?.payload);
        state.isAppLoading = false;
        state.changeCompany = null;
      })
      .addCase(getIntercomDetailData.pending, (state) => {})
      .addCase(getIntercomDetailData.fulfilled, (state, action) => {
        const appDataFromResponse = action?.payload;
        if (appDataFromResponse) {
          try {
            state.intercomDetail = appDataFromResponse;
          } catch (error) {
            logErrorWithPayload(error, appDataFromResponse);
          }
        }
      })
      .addCase(getIntercomDetailData.rejected, (state, action) => {
        logErrorWithPayload(action?.error, action?.payload);
        state.intercomDetail = "";
      })
      .addCase(getDemDxDetailData.pending, (state) => {})
      .addCase(getDemDxDetailData.fulfilled, (state, action) => {
        const appDataFromResponse = action?.payload;
        if (appDataFromResponse !== "" && appDataFromResponse !== null) {
          localStorage.setItem("demDexToken", appDataFromResponse);
        } else {
          localStorage.setItem("demDexToken", "");
        }
      })
      .addCase(getDemDxDetailData.rejected, (state, action) => {
        logErrorWithPayload(action?.error, action?.payload);
        localStorage.setItem("demDexToken", "");
      });
  },
});

// Action creators are generated for each case reducer function
export const {
  setIsValidOrg,
  setIsChatVisible,
  setIsOrbitSessionData,
  setIsSelectionScreenData,
  setIsTeamUpdatedData,
  setIsSelectedTeamIndexData,
  setIsAppLoading,
  setIsTabLoading,
  setAuthToken,
  removeAuthToken,
  setDarkModeTheme,
  setPharmacy,
  setTeam,
  setOrbitUser,
  setPharmaciesData,
  resetAppState,
  replaceAppState,
  setShowPatientSearchModalData,
  setHeaderTeamMembersData,
  setShowInviteModalData,
  setShowInviteTeamSideModalData,
  setGlobalTab,
  setGlobalTabText,
  setisAgencyUserData,
  setCurrentTeamIdData,
  setCurrentIsPatientSearched,
  setCurrentPatientInfoTab,
  setCurrentTeamsData,
  setRoutedFromSchedulerData,
  setShowProfileModalData,
  setConsultationLoadErrorData,
  setShowIdlePopupData,
  setShowSettingsModalData,
  setSettingsActiveTabData,
  setShowPermissionModalData,
  setShowPermissionMessageData,
  setCompanyIdData,
  setCurrentCompanyIdData,
  setDasboardTeam,
} = appSlice.actions;

export default appSlice.reducer;
